export const WHITE_LIST = {
  AI_LAB: 'aigc_all',
  SHOPPING_HELP: 'aiGuide_all',
  NOTHING: '',
} as const;
